
import { i18nText } from '@/locales';
import {Form} from "@/form/form";
import {Component} from "vue-property-decorator";
import { SiteVacancySectionRequestType } from "./vacancy_section.types";
import {Validate} from "@/plugins/Vuelidate/Decorators";
import {maxLength, minLength, numeric, required} from "vuelidate/lib/validators";
import { IVacancySection, IVacancySectionListItem } from "@/entity/Settings/vacancy_section.types";

@Component
export default class SiteVacancySectionForm extends Form {

    @Validate(required, i18nText("Введите назавание категории"))
    id: number | null = null;
    title: string | null = null;
    subtitle: string | null = null;
    description: string | null = null;


    getFormData(): SiteVacancySectionRequestType {
       return{
        id: this.id,
        title: this.title,
        subtitle: this.subtitle,
        description: this.description,
       } 
    }

    setFormData(vacancy_section: IVacancySection | null): void {
        if (vacancy_section !== undefined && vacancy_section != null)
        {
            for(let i = 0; i < vacancy_section.data.length; i++){
                this.id = vacancy_section.data[i].id;
                this.title = vacancy_section.data[i].title;
                this.subtitle = vacancy_section.data[i].subtitle;
                this.description = vacancy_section.data[i].description;
            }
        }
    }
}
